"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UIPLAT/Card
 */
var React = require("react");
var classNames = require("classnames");
var InternalInput_1 = require("../../components/form/inputs/InternalInput");
var Aria_1 = require("../../resources/Aria");
var util_1 = require("../../utils/util");
/**
 * OUI card component.
 *
 * @oui-component Card
 */
var Card = function (_a) {
    var onClick = _a.onClick, label = _a.label, rest = __rest(_a, ["onClick", "label"]);
    var className = classNames("oui-info-card", {
        "oui-info-card--clickable": onClick !== undefined
    });
    var buttonProps = __assign({ onClick: onClick,
        className: className, from: "div", role: Aria_1.Roles.Button }, rest, util_1.ariaProps({ label: label }));
    // @ts-ignore: this will be fixed with update to @oui/core
    return React.createElement(InternalInput_1.default, __assign({}, buttonProps));
};
exports.default = Card;
//# sourceMappingURL=Card.js.map